import { MenuItem } from '@mui/material';
import styled from 'styled-components';

export const StyledMenuItem = styled(MenuItem)`
  color: #1e164e;
  font-size: 14px;
  height: 40px;
  box-sizing: border-box;
  padding: 10px 16px 10px 16px;
  font-weight: 500;

  &.Mui-disabled {
    cursor: not-allowed;
    pointer-events: auto;
    opacity: 0.5;
    .option-btn {
      cursor: not-allowed;
      opacity: 0.5;
    }
  }

  .option-btn {
    width: 40px;
    height: 40px;
    padding: 12px;
    &:hover {
      background-color: transparent;
    }
  }
`;

export const StyledActionWarning = styled('div')`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0px 24px;
  .btn-non-vbee-warning {
    text-transform: none;
    height: 40px;
    border-radius: 12px;
  }
`;

export const StyleListSpeakers = styled('div')`
  position: relative;
  width: 233px;
`;

export const StyleListSpeakersItem = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 56px;
  padding: 8px 12px;
  box-sizing: border-box;
`;

export const StyleListSpeakersContent = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 16px 16px 16px;
  margin-top: 12px;
`;
